// extracted by css-extract-rspack-plugin
var _1 = "mbGrW9ukBDbh9ZwHbVwQDg--";
export { _1 as "inputInfo" }
